import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber',
  standalone: true
})
export class ToNumberPipe implements PipeTransform {

  transform(v?: string | null): number {
    return v ? +v.replaceAll(',', '.').replaceAll(' ', '') : 0.00;
  }

}
